import { RichText } from "components/RichTextWidget";
import { Container, Heading3, Paragraph, RenderIf } from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";

import styles from "./Content045.module.scss";
import { Item } from "./Item";

export const Content045 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const note = payload?.note ?? "";
  const blocks = payload?.blocks ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <div className={styles.content}>
            <Heading3 className={styles.title}>{title}</Heading3>
            <div className={styles.text}>
              <RichText value={description} className={styles.description} />
              <RenderIf viewMode={VIEW_MODES.DESKTOP}>
                <Paragraph color="grey" className={styles.note}>
                  {note}
                </Paragraph>
              </RenderIf>
            </div>
          </div>
          <Item items={blocks} />
          <RenderIf viewMode={VIEW_MODES.MOBILE}>
            <Paragraph color="grey" className={styles.note}>
              {note}
            </Paragraph>
          </RenderIf>
        </div>
      </Container>
    </div>
  );
};

export default Content045;
